import React, { useRef } from "react";

const DateInput = ({ name, value, onChange, placeholder, className, ...props }) => {
  const inputRef = useRef(null);
  
  const handleChange = (e) => {
    if (typeof onChange === 'function') {
      if (onChange.length === 1) {
        // It's expecting an event
        onChange(e);
      } else {
        // It's likely a state setter
        onChange(e.target.value);
      }
    }
  };

  return (
    <div
      className="relative w-56 min-w-56 max-w-56 shrink-0 cursor-pointer"
      onClick={() => inputRef.current?.showPicker()}
    >
      {!value && (
        <span className="absolute text-sm text-gray-500 font-SuisseIntlLight left-6 top-1/2 transform -translate-y-1/2 pointer-events-none">
          {placeholder}
        </span>
      )}
      <input
        ref={inputRef}
        name={name}
        type="date"
        className={`w-full rounded-md border font-SuisseIntlLight border-slate-200 bg-white px-3 py-2 text-sm ring-offset-white file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-medium file:text-[#71717a] placeholder:text-[#71717a] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#71717a] focus-visible:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 z-10 bg-transparent appearance-none ${value ? '' : '[&::-webkit-datetime-edit]:opacity-0'} focus:outline-none ${className || ''}`}
        value={value || ''}
        onChange={handleChange}
        {...props}
      />
    </div>
  );
};

export { DateInput };
